import { apiPost } from "../baseApi";
import { setUserData } from "service/mapper";

export const create = async (data) => {
  try {
    const response = await apiPost("_addUser", data);
    return { ...response, data: setUserData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
